// extracted by mini-css-extract-plugin
export default {"card":"wMhU9_","card--bordered":"DdLjgv","card--with-hover":"dgjeT3"};